import type { FaireProductEntity } from "../../entity_types/product";

export const p_vju8vk484w: FaireProductEntity = {
  token: "p_vju8vk484w",
  type: "product",
  name: "Melati Fresh Zero-Alcohol Botanical Spirit (no gift box)",
  brandToken: "b_5p3hx22es9",
  brandName: "Melati Drinks",
  imageUrl:
    "https://cdn.faire.com/fastly/4ec665d1e43c57fe25b85af05589a18bb3b8dfb09ad76942b60a7d7b532e92e4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/68a9c6f89ad65b2dcdfdf90deb797df3c92f29fa75018c7b5f132b340ceecaa5.png",
    "https://cdn.faire.com/fastly/fe8a7a0e7bf6f4ffcd6ecb3f65a5ecea4a5e4926bea3276b0a0771cbb6d9237d.jpeg",
    "https://cdn.faire.com/fastly/d1ab0b450f6b2f173a9846a02050c5721eb681d62daa79f7352a28b3750c4961.jpeg",
  ],
  priceDollars: 42.96,
  description:
    "Melati Drinks is Asia's First Non-Alcoholic Spirit. Born out of the royal courts of the Far East, we uncovered botanical tonic recipes served since 1293. Travel through the magnificent volcanic highlands of Asia in a bold, delicious and healthy alcohol alternative. Savor uplifting goji berries, aromatic Asian spices and a long dry bitter finish. Let’s raise a glass to your health!\n\nEach bottle directly supports women's future in Indonesia and is ethically made within a circular economy.\n\nTropical, mineral and aromatic, Melati Fresh is a bold non-alcoholic spirit with bright acidity and a dry finish for white wine lovers. Tropical green mango, zesty lime rind and aromatic thai basil are grounded by warm Asian spices and cool fresh mint. Bright and complex, Fresh is best enjoyed with soda water in a champagne glass for a sophisticated drink.  \n",
  tags: [],
  msrpDollars: 62.36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:58.239Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
